module.exports = __webpack_public_path__ + "assets/a9ee34adebe9ee11704f30ec807b0201.png";